/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsForVmware extends models.ServiceAccountEphemeralCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountEphemeralCredentialsForVmware");
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsForVmware.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsForVmware>): ServiceAccountEphemeralCredentialsForVmware {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsForVmware(), model);
        ServiceAccountEphemeralCredentialsForVmware.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsForVmware>): ServiceAccountEphemeralCredentialsForVmware {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsForVmware.newInstance(<ServiceAccountEphemeralCredentialsForVmware> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsForVmware) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsForVmware.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsForVmware): boolean {
        if (models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountEphemeralCredentialsForVmware.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.token_created_at === "string") {
            this.token_created_at = new Date(<string><any>this.token_created_at);
        }
    }

    /**
     * Access Token
     */
    access_token: string;

    /**
     * Access Token Generated Timestamp
     */
    token_created_at: Date;

}
